import { render } from "./ViewAllGamesPage.vue?vue&type=template&id=063e4974"
import script from "./ViewAllGamesPage.vue?vue&type=script&lang=js"
export * from "./ViewAllGamesPage.vue?vue&type=script&lang=js"

import "./ViewAllGamesPage.vue?vue&type=style&index=0&id=063e4974&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__